import React, { useState } from "react";
import logoImg from "../Includes/Images/Final_logo_Black.png";
// import "./Footer.css";
import { Link } from "react-router-dom";

export default function Footer() {
  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleDropdown = (dropdown) => {
    if (activeDropdown === dropdown) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdown);
    }
  };

  return (
    <>
      <div className="container">
        <div className="lc-cta-section">
          <div className="lc-call-container">
            <h2 className="lc-cta-heading">Give Us a Call</h2>
            <p className="lc-cta-subheading">Let's Find You Something Better.</p>
            <a href="tel:+1-888-348-6689" className="lc-phone-btn">
              +1-888-348-6689
            </a>
            <p className="lc-availability">
              Available Monday through Sunday, 24 Hours a Day.
            </p>
          </div>

          <div className="lc-newsletter-container">
            <h2 className="lc-cta-heading">
              Get industry updates, and latest promotions delivered directly to
              your inbox
            </h2>
            <p className="lc-cta-subheading">Subscribe to our Newsletter:</p>
            <form className="lc-form">
              <div className="lc-form-inputs">
                <input
                  type="text"
                  placeholder="Name*"
                  className="lc-input"
                  required
                />
                <input
                  type="email"
                  placeholder="Email*"
                  className="lc-input"
                  required
                />
              </div>
              <button type="submit" className="lc-submit-btn">
                Sign Up
              </button>
            </form>
            <p className="lc-disclaimer">
              We are a complete disclosure brand, check out our{" "}
              <a href="#" className="lc-link">
                Privacy Policy
              </a>{" "}
              before you commit.
            </p>
          </div>
        </div>
      </div>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section footer-about">
            <img
              src={logoImg}
              alt="symzitechsolutions Logo"
              className="footer-logo"
            />
            <p>
              In our rankings of the Best Internet Service Providers of 2023,
              symzitechsolutions Internet is tied for first place in both the Best
              Fibre Internet Providers and Fastest High-Speed Internet Service
              Providers rankings.
            </p>
            <div className="subscribe-form">
              <input type="email" placeholder="Your Email" />
              <button aria-label="Subscribe">→</button>
            </div>
            <p className="subscribe-note">
              Subscribe today and get wonderful offers.
            </p>
          </div>

          <div className="footer-section">
            <h3>Services</h3>
            <ul className="footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              {/* <li>
                <Link to="/plans">Plans</Link>
              </li> */}
              {/* <li>
                <Link to="/services">Services</Link>
              </li> */}
              <li className="footer-dropdown-container">
                <div
                  className="footer-dropdown-toggle"
                  onClick={() => toggleDropdown('provider')}
                >
                  Providers <i className={`fas fa-chevron-${activeDropdown === 'provider' ? 'up' : 'down'}`}></i>
                </div>
                <ul className={`footer-dropdown-menu provider-dropdown ${activeDropdown === 'provider' ? 'active' : ''}`}>
                  <li><Link to="/xfinity" className="dropdown-item" onClick={() => setActiveDropdown(null)}>Xfinity</Link></li>
                                   <li><Link to="/spectrum" className="dropdown-item" onClick={() => setActiveDropdown(null)}>Spectrum</Link></li>
                                   <li><Link to="/earthlink" className="dropdown-item" onClick={() => setActiveDropdown(null)}>Earthlink</Link></li>
                                   <li><Link to="/hughesnet" className="dropdown-item" onClick={() => setActiveDropdown(null)}>Hughesnet</Link></li>
                                   <li><Link to="/wow" className="dropdown-item" onClick={() => setActiveDropdown(null)}>WOW!</Link></li>
                                   <li><Link to="/att" className="dropdown-item" onClick={() => setActiveDropdown(null)}>AT&T</Link></li>
                                   <li><Link to="/optimum" className="dropdown-item" onClick={() => setActiveDropdown(null)}>Optimum</Link></li>
                                   <li><Link to="/ziplyfiber" className="dropdown-item" onClick={() => setActiveDropdown(null)}>Ziplyfiber</Link></li>
                                   <li><Link to="/cox" className="dropdown-item" onClick={() => setActiveDropdown(null)}>Cox</Link></li>
                                   <li><Link to="/viasat" className="dropdown-item" onClick={() => setActiveDropdown(null)}>Viasat</Link></li>
                                   <li><Link to="/kinetic" className="dropdown-item" onClick={() => setActiveDropdown(null)}>Kinetic</Link></li>
                                   <li><Link to="/fidium" className="dropdown-item" onClick={() => setActiveDropdown(null)}>Fidium</Link></li>
                                   <li><Link to="/directv" className="dropdown-item" onClick={() => setActiveDropdown(null)}>Directv</Link></li>
                                   <li><Link to="/metronet" className="dropdown-item" onClick={() => setActiveDropdown(null)}>Metronet</Link></li>
                </ul>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/term-and-conditions">Terms&Conditions</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Us</h3>
            <div className="contact-info">
              <p>
                <span>Address:</span> 736 Sterling Dr, Ste 100, Murphy, TX 75001,
                United States
              </p>
            </div>
            <div className="contact-info">
              <p>
                <span>Email:</span>{" "}
                <a href="mailto:info@symzitechsolutions.com">
                  info@symzitechsolutions.com
                </a>
              </p>
            </div>
            <div className="contact-info">
              <p>
                <span>Contact No:</span>{" "}
                <a href="tel:+1-888-348-6689">+1-888-348-6689</a>
              </p>
            </div>
            <div className="social-icons">
              <a href="#" className="social-icon" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="social-icon" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="social-icon" aria-label="LinkedIn">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="#" className="social-icon" aria-label="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="copyright">
          © {new Date().getFullYear()} Powered by Symzitechsolutions All Rights
          Reserved
        </div>
      </footer>

      <style>
        {`
         /* Footer dropdown specific styles */
.footer-dropdown-container {
  position: relative;
  z-index: 100;
}

.footer-dropdown-toggle {
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
}

.footer-dropdown-toggle i {
  margin-left: 5px;
}

.footer-dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  min-width: 180px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 8px 16px rgba(0,0,0,0.1);
  z-index: 101;
  border-radius: 4px;
  padding: 8px 0;
}

.footer-dropdown-menu.active {
  display: block;
}

.footer-dropdown-menu .dropdown-item {
  color: #333;
  padding: 8px 16px;
  text-decoration: none;
  display: block;
  white-space: nowrap;
}

.footer-dropdown-menu .dropdown-item:hover {
  background-color: #f5f5f5;
}

/* Make sure the footer has sufficient overflow handling */
.footer {
  position: relative;
  overflow: visible;
}

.footer-content {
  position: relative;
  overflow: visible;
}

.footer-links {
  position: relative;
  overflow: visible;
}
        `}
      </style>
    </>
  );
}